import React from "react";
import image from "../assets/images/coin.jpg";
import TopHeader from "../components/TopHeader";
import Calculator from "../components/Calculator";

export default function LoanCalculator() {
  return (
    <section className="bg-gray-100 min-h-screen ">
      {/* Header */}
      <div
        className="relative bg-cover bg-center h-100 items-center flex justify-center"
        style={{ backgroundImage: `url(${image})` }}
      >
        <div className="absolute inset-0 bg-black/50"></div>
        <TopHeader title="Loan Calculator" subtitle="Loan Calculator" />
      </div>
      <div className="bg-white max-w-6xl mx-auto w-full p-4">
        <Calculator />
      </div>
    </section>
  );
}
